import React, { useEffect, useState, useContext } from 'react'
import { db, auth } from '../firebase'
import { onSnapshot, collection, query, where, limit, orderBy } from "firebase/firestore"
import NewQuestion from '../component/questionsStuff/NewQuestion';
import Loader from '../component/ui/Visual-utilities/Loader';


import d20 from './PendingQuestions.module.css'

import { IoCloudOfflineOutline } from 'react-icons/io5'
import { GrClose } from 'react-icons/gr'
import { GiNightSleep } from 'react-icons/gi'

import Card from '../component/ui/Card';
import { Link } from 'react-router-dom';
import { BsPlusCircle, BsWhatsapp } from 'react-icons/bs'
import ListQuestions from '../component/questionsStuff/ListQuestions';
import UserContext from '../store/UserContext';
import NoEnoughCredits from '../component/NoEnoughCredits'
import NotificationPermissionHandler from '../component/NotificationPermissionHandler';

function PendingQuestions() {

  const userCtx = useContext(UserContext);
  let userData = userCtx.user;

  const [renew, setRenew] = useState(false);
  const [schedule, setSchedule] = useState(false)

  const QuestCollRef = collection(db, 'questions')
  const [questions, setQuestions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [askButton, setAskButton] = useState(false);




  useEffect(() => {

    let isMounted = true;//clean up
    try {
      const q = query(QuestCollRef, where("sender_id", "==", auth.currentUser.uid), where("question_status", "!=", 'done'), orderBy("question_status"), orderBy('createdAt', 'desc'), limit(40));

      const getusers = () => {
        onSnapshot(q,
          snapshot => {
            if (isMounted) setQuestions(snapshot.docs.map((docu) => ({ ...docu.data(), question_id: docu.id })))
            setIsLoading(false);
          }
        );
      }
      getusers();
      setRenew(true);
      setSchedule(true);
    }
    catch (e) { console.log(e) }
    return () => { isMounted = false };//clean up function call
  }, [])


  //current hour
  let hr = new Date().getHours().toString();


  // const q=(questions.filter((n)=>{return !n.answer && !n.answer_img && !n.answer_audio;}));
  const filterLenght = questions.length;


  return (<div className='MainSplitContainer' >

<div className={'leftContainer ' }>
  
<div >

      {isLoading && <Loader />}

      <NotificationPermissionHandler />
      {!((hr >= 15 && hr < 18) || (hr >= 20 && hr < 24)) && schedule &&
        <Card >
          <div className={d20.schedule}>
            <button className={d20.scheduleClose} onClick={() => setSchedule(false)}>  <GrClose size='25' /></button>
            <div className={d20.unavailable} >
              <div className={d20.unavailableMainMessage}>We are currently unavailable <GiNightSleep /> </div>
              <br /> We are online between <b> 3pm-6pm  , 8pm-12pm </b>
              <br /> You can always ask your questions and we will reply as soon as possible, thank you</div>

          </div>
        </Card>
      }

      {/* {userData.daysLeft<=5 && renew &&
         <Card >
          <div className={d20.schedule}>
            <button className={d20.scheduleClose} onClick={()=>setRenew(false)}>  <GrClose size='25' /></button>
              <div className={d20.unavailable} > 
                <Link to='/payments' >
                <div className={d20.RenewMainMessage}>Your account has only {userData.daysLeft} days left <IoCloudOfflineOutline/> </div>
                </Link>
              <br/><p> renew subscription before <b> {userData.expiry_date !== undefined ?userData.expiry_date.toDate().toString().substring(0,25):null} </b>else your account will be disactivated</p>
              </div>
          </div>         
         </Card> */}


      {userData.credits <= 5 && renew &&
        <Card >
          <div className={d20.schedule}>
            <button className={d20.scheduleClose} onClick={() => setRenew(false)}>  <GrClose size='25' /></button>
            <div className={d20.unavailable} >
              <Link to='/payments' >
                <div className={d20.RenewMainMessage}>Your account has only {userData.credits} credits left <IoCloudOfflineOutline /> </div>
              </Link>
              <br /><p>Kindly get more credits so you can <b> keep benefiting from our services</b></p>
            </div>
          </div>
        </Card>
      }



      {askButton && <NewQuestion onClick={() => setAskButton(false)} />}

      <div className={d20.PageheaderText}>Waiting to be answered:</div>

      <ListQuestions data={questions} onClick={() => {}} />

      {userCtx.user.credits > 0 ?
        <>
          {!isLoading && ((filterLenght < 5) ? <button onClick={() => setAskButton(true)} className={d20.askButton}>Ask A Question ? <BsPlusCircle /></button> : <div className={d20.QuestionTextLimit}>to keep you in focus you are only allowed to ask<b> five questions at a time</b></div>)}
        </>
        : <NoEnoughCredits />}
    </div> </div>


    <div className="rightContainer">
    <div className="not_sign__shape">
              <img className="circle" src="/assets/img/icon/sign/circle.png" alt="img not found"/>
                  <img className="zigzag" src="/assets/img/icon/sign/zigzag.png" alt="img not found"/>
                  <img className="dot" src="/assets/img/icon/sign/dot.png" alt="img not found"/>
                  <img className="flower" src="/assets/img/icon/sign/flower.png" alt="img not found"/> 
                  
                  <div className="center_logo d-flex flex-column justify-content-center2 align-content-center">
                  <img className='logo' src="/assets/img/logo/questa logo.png" alt="img not found"/>
                  <p className=' under_logo text-center'>For any help feel free to reach us out on<a className="" href='https://wa.me/message/EQMDVYMG5NXJK1'><br/><b> 81 184 763<BsWhatsapp /></b> </a></p>
                  </div>

                  
              </div> 
               
             </div> 
              </div>
  

    




  )
}

export default PendingQuestions

